module.exports = __webpack_public_path__ + "static/media/whatsapp.ab6e1c2e.svg";